import { hideVisually, rem } from 'polished';
import styled from 'styled-components';

import { IStyledWrapperProps } from './Accordion.types';

export const StyledArrow = styled.span`
  position: absolute;
  top: ${rem('21px')};
  right: 0;
  display: flex;
  flex-direction: column;
  flex-grow: 0;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: ${rem('40px')};
  height: ${rem('40px')};
  border-radius: 100%;
  pointer-events: none;

  svg {
    width: ${rem('11px')};
    height: auto;
  }
`;

export const StyledPanel = styled.div`
  padding-bottom: ${({ theme }) => rem(theme.spacings.s)};
  color: ${({ theme }) => theme.colors.cross.grayson};
  font-size: ${({ theme }) => rem(theme.spacings.s)};
  font-weight: 400;
  line-height: 1.4;

  a {
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const StyledButton = styled.button`
  position: relative;
  display: block;
  width: 100%;
  padding: ${({ theme }) => rem(theme.spacings.m)} ${rem('50px')}
    ${({ theme }) => rem(theme.spacings.m)} 0;
  font-size: ${rem('20px')};
  font-weight: 300;
  line-height: 1.4;
  text-align: left;
  background: transparent;
  border: none;
  border-radius: 0;
  cursor: pointer;
  appearance: none;

  &:focus {
    outline: none; //TODO add proper focus style
  }

  &[aria-expanded='false'] {
    color: ${({ theme }) => theme.colors.cross.black};

    & + ${StyledPanel} {
      ${hideVisually()};
    }
  }

  strong {
    font-weight: 600;
  }
`;

export const StyledItem = styled.li`
  list-style: none;
  border-bottom: 1px solid ${({ theme }) => theme.colors.cross.silverFox};
`;

export const StyledWrapper = styled.ul<IStyledWrapperProps>`
  margin: 0;
  padding: 0;

  ${({ boxed, theme }) =>
    boxed &&
    `
    padding: 0 ${rem(theme.spacings.s)};
    background-color: ${theme.colors.main};
    border-radius: ${rem(theme.spacings.s)};

    & ${StyledItem}:last-child {
      border-bottom: none;
    }

    @media screen and (max-width: ${theme.breakpoints.m}) {
      padding: 0;
    }
  `}

  ${({ theme, user }) =>
    user &&
    `
    ${StyledButton}[aria-expanded='true'] {
      color: ${theme.colors[user].main};

      ${StyledArrow} svg {
        transform: rotate(180deg);
      }
    }

    ${StyledPanel} a {
      color: ${theme.colors[user].main};
    }
  `}
`;
